import { useCallback, useEffect, useMemo, useState } from "react";
import CustomButton from "../../../../components/CustomButton";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../helpers/apiHelper";
import ModalWrapper from "../../../../components/Modal/ModalWrapper";
import Dropdown, { DropdownValue } from "../../../../components/misc/Dropdown";
import Text from "../../../../styleguide/Text";
import {
  fetchCargoCarPickupCargoInternodeRoute,
  postClosePackageCargoInternode,
} from "../../../../redux/api/raports.api";
import { getReasonsNomenclature } from "../../../../redux/api/admin.api";
import {
  clearPickupCargoInternodeRoute,
  closePackageCargoInternodeRouteModal,
  setSelectedCargoInternodeItemForClosing,
} from "../../../../redux/reducer/raports.reducer";

export interface SelectedItemCargoInternodeForClosingInterface {
  id: number | string;
  type: "COLET" | "BIN";
}

function ClosePackageCargoInternodeModal({
  id_ruta_intranod,
  id_nod_curent,
  id_nod_start,
  id_nod_stop,
}: {
  id_ruta_intranod?: string | number | undefined;
  id_nod_curent?: string | number | undefined;
  id_nod_start?: string | number | undefined;
  id_nod_stop?: string | number | undefined;
}) {
  const dispatch = useAppDispatch();

  const {
    raports: {
      isClosePackageCargoInternodeRouteModalOpen,
      selectedItemCargoInternodeForClosing,
    },
    admin: {
      reasonsNomenclature: {
        data: { data: reasonNomenclatureData },
      },
    },
  } = useAppSelector((state) => ({
    raports: state.raports,
    admin: state.admin,
  }));

  const [selectedReason, setSelectedReason] = useState<DropdownValue | null>(
    null,
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    dispatch(
      getReasonsNomenclature({
        page: 1,
        perPage: 100,
        denumire: "",
        type: 10,
        operatie: 1,
      }),
    );
  }, [dispatch]);

  const handleOnSubmit = useCallback(async () => {
    if (!selectedItemCargoInternodeForClosing || !selectedReason) return;

    setIsLoading(true);

    const payload: any = {
      id_motiv: selectedReason.id,
    };

    if (selectedItemCargoInternodeForClosing.type === "BIN") {
      payload.id_bin = selectedItemCargoInternodeForClosing.id;
    } else {
      payload.id_doctrans_detl = selectedItemCargoInternodeForClosing.id;
    }

    const resultAction = await dispatch(
      postClosePackageCargoInternode(payload),
    );

    if (
      checkEndpointStatus(resultAction, postClosePackageCargoInternode) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, postClosePackageCargoInternode) ===
      endpointStatus.fulfilled
    ) {
      dispatch(clearPickupCargoInternodeRoute());

      dispatch(
        fetchCargoCarPickupCargoInternodeRoute({
          id_ruta_intranod,
          id_nod_curent,
          id_nod_start,
          id_nod_stop,
        }),
      );

      setSelectedReason(null);
      dispatch(setSelectedCargoInternodeItemForClosing(null));
      dispatch(closePackageCargoInternodeRouteModal());
    }
  }, [
    dispatch,
    selectedItemCargoInternodeForClosing,
    selectedReason,
    id_ruta_intranod,
    id_nod_curent,
    id_nod_start,
    id_nod_stop,
  ]);

  const handleClose = () => {
    dispatch(closePackageCargoInternodeRouteModal());
    setSelectedReason(null);
  };

  const reasonNomenclatureDataDropdownValues = useMemo(
    () =>
      reasonNomenclatureData?.map((item) => ({
        label: item.denumire,
        id: item.id_motiv,
      })),
    [reasonNomenclatureData],
  );

  const isBin = selectedItemCargoInternodeForClosing?.type === "BIN";

  return (
    <ModalWrapper
      show={!!isClosePackageCargoInternodeRouteModalOpen}
      title={isBin ? "Inchidere Bin" : "Inchidere colet"}
      modalSize="md"
      handleClose={handleClose}>
      <Dropdown
        title={
          isBin ? "Motivul inchiderii binului" : "Motivul inchiderii coletului"
        }
        data={reasonNomenclatureDataDropdownValues}
        singleValue={selectedReason}
        setSingleValue={setSelectedReason}
      />

      <CustomButton
        type="submit"
        variant="contained"
        fullWidth
        className="btn btn-lg btn-primary w-100 mt-5"
        disabled={!selectedItemCargoInternodeForClosing || !selectedReason}
        loading={isLoading}
        onClick={handleOnSubmit}>
        <Text variant="body1" isBold>
          Salveaza
        </Text>
      </CustomButton>
    </ModalWrapper>
  );
}

export default ClosePackageCargoInternodeModal;
